import React from "react";
import { optimizeCloudinaryImage } from "@/services/CloudinaryService";
import { Lazy } from "../Lazy";

import { FeedbackHeroProps } from "./types";
import { FEEDBACK_PREVIEW_INDEX } from "@/utils/feedbackPreviewNavigation";

export const FeedbackHero = ({ data, currentView, isInitPreview }: FeedbackHeroProps) => {
  const { logoUrl, themeColor } = data;

  if (!logoUrl) return <></>;
  return (
    <div
      className={`feedback-top--container ${
        currentView === FEEDBACK_PREVIEW_INDEX.THANK_YOU ? "thankYou-view" : ""
      } `}
      style={{ background: themeColor?.backgroundColor }}
    >
      {logoUrl &&
        (isInitPreview ? (
          <Lazy placeholderClass="skeleton-placeholder__links__image">
            <img
              src={logoUrl}
              alt="feedback preview"
            />
          </Lazy>
        ) : (
          <Lazy placeholderClass="feedback-logo">
            <img
              src={optimizeCloudinaryImage({
                url: logoUrl,
              })}
              className="feedback-logo"
            />
          </Lazy>
        ))}
    </div>
  );
};
